import { NotifyHelper } from "../../../helpers/toast";
import { eNhapKhoActionTypeDefine } from "../../action-types/category/INhapKhoActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const nhapKhoActions = {
    ...generateActions(eNhapKhoActionTypeDefine, "NHAP_KHO"),
    ...generateActionForKey(eNhapKhoActionTypeDefine, "NHAP_KHO", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eNhapKhoActionTypeDefine, "NHAP_KHO", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eNhapKhoActionTypeDefine, "NHAP_KHO", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eNhapKhoActionTypeDefine, "NHAP_KHO", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eNhapKhoActionTypeDefine, "NHAP_KHO", "SAVE_IMPORT_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eNhapKhoActionTypeDefine, "NHAP_KHO", "SAVE_IMPORT_ERROR", (m) => { NotifyHelper.Error(m) }),
}